<template lang="html">
  <div class="avatar-container">
    <div class="card text-center">
      <div class="card-body">
        <img
          :src="currentUser.avatar_url"
          class="avatar img-thumbnail rounded-circle"
        />
        <div class="card-img-overlay">
          <button class="btn btn-unstitched btn-sm" id="pick-avatar">
            Change
          </button>
        </div>
      </div>
      <div class="card-foot1er text-muted" v-html="message"></div>
      <avatar-cropper
        @uploading="handleUploading"
        @completed="handleCompleted"
        @error="handlerError"
        :cropper-options="{ autoCropArea: 1, aspectRatio: 1 }"
        :labels="{ submit: 'Upload', cancel: 'Cancel' }"
        trigger="#pick-avatar"
        upload-url="https://demo.overtrue.me/upload.php"
      />
    </div>
  </div>
</template>

<script>
import AvatarCropper from "vue-avatar-cropper";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    AvatarCropper
  },

  data() {
    return {
      message: null
    };
  },

  computed: {
    ...mapGetters(["currentUser"])
  },

  methods: {
    ...mapActions(["handleUpdateUserDetails"]),

    handleUploading(form, xhr) {
      this.message = "uploading...";
      const payload = {
        userId: this.currentUser.id,
        formData: form
      };

      // NOTE: The .then might not be needed because of handleCompleted()
      // Currently required because user not returning correctly from backend
      this.handleUpdateUserDetails(payload).then(() => {
        this.message = null;
      });
    },

    handleUploaded(response) {},

    handleCompleted(response, form, xhr) {
      this.message = "upload completed.";

      const that = this;
      setTimeout(function() {
        that.message = null;
      }, 2000);
    },

    handlerError(message, type, xhr) {
      this.message = "Oops! Something went wrong...";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
.card {
  border: none;
  box-shadow: none;
  margin: 0 auto;
}

.card-body {
  padding: 0;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}

.card-img-overlay {
  display: none;
  transition: all 0.5s;

  #pick-avatar {
    position: absolute;
    left: 40px;
    bottom: 0px;
  }
}

.card:hover .card-img-overlay {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/account/AvatarUploader.vue